module.exports = __webpack_public_path__ + "img/mc-donald-thumbnail-small.e3992338.png";